
import { Vue, Component, PropSync, Prop } from "vue-property-decorator";
import ButtonDownloadDropdown from "@/components/Base/Reports/ButtonDownloadDropdown.vue";
import ButtonDownload from "@/components/Base/Reports/ButtonDownload.vue";

@Component({ components: { ButtonDownloadDropdown, ButtonDownload } })
export default class BaseToolbar extends Vue {
  @Prop({ required: false, default: false })
  pinFilterDrawer!: boolean;

  @Prop({ required: false, default: false })
  downloading!: boolean;

  @Prop({ required: false, default: "Download" })
  downloadLabel!: string;

  @Prop({ required: false, default: "Download Report" })
  downloadToolTip!: string;

  @Prop({ required: false, default: false })
  showDownloadButton!: boolean;

  @Prop({ required: false, default: false })
  enabled!: boolean;

  @Prop({
    required: false,
    default: () => {
      return;
    },
  })
  downloadButtonOnClick!: () => void;

  @PropSync("showFilter", { type: Boolean, default: null })
  showFilterSync!: boolean;

  @PropSync("showChart", { type: Boolean, default: null })
  showChartSync!: boolean;

  get hasDownload() {
    return this.$slots.downloadableItems;
  }
}
